export const DM_SERVICE_HEADERS = {
  'atproto-proxy': 'did:web:api.bsky.chat#bsky_chat',
}
